/** Type of an item on the design. */
export enum DesignItemType {
  folder = 'folder',
  intent = 'intent',
  module = 'module',
  object = 'object',
  variable = 'variable'
}
